import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = (token) =>
  axios.create({
    baseURL: API,
    headers: { Authorization: `Bearer ${token}` },
  });

export const BUSINESS = {
  name: "On The Go Gloss Mobile Detailing",
  short: "OTGG",
  phone: "407-795-2561",
  phoneHref: "tel:+14077952561",
  smsHref: "sms:+14077952561",
  instagram: "onthegoglossdetails",
  instagramUrl: "https://instagram.com/onthegoglossdetails",
  tiktok: "onthegoglossdetails",
  tiktokUrl: "https://tiktok.com/@onthegoglossdetails",
  facebook: "On The Go Gloss",
  facebookUrl: "https://www.facebook.com/search/top?q=on%20the%20go%20gloss",
  googleReviewUrl: "https://share.google/1b9zHVYWz9F7tV8zJ",
  googleRating: 5.0,
  tagline: "Interior · Exterior · Full Detail",
  serviceArea: "Manchester & surrounding areas",
  logo: "https://customer-assets.emergentagent.com/job_mobile-car-shine-2/artifacts/mux39vjg_IMG_1195.jpeg",
  heroImage: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mobile-car-shine-2/artifacts/hsn53ppd_IMG_2348.webp",
  exteriorImage: "https://customer-assets.emergentagent.com/job_mobile-car-shine-2/artifacts/zkic4r9f_IMG_1176.jpeg",
  interiorImage: "https://customer-assets.emergentagent.com/job_mobile-car-shine-2/artifacts/zwg7aee1_IMG_1053.jpeg",
  galleryImage: "https://customer-assets.emergentagent.com/job_mobile-car-shine-2/artifacts/12xqi4mw_IMG_1129.jpeg",
  galleryImages: [
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_mobile-car-shine-2/artifacts/hsn53ppd_IMG_2348.webp",
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_mobile-car-shine-2/artifacts/znsv9zxr_IMG_2351.webp",
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_mobile-car-shine-2/artifacts/yeptul3m_IMG_2352.webp",
    "https://customer-assets.emergentagent.com/job_mobile-car-shine-2/artifacts/zkic4r9f_IMG_1176.jpeg",
    "https://customer-assets.emergentagent.com/job_mobile-car-shine-2/artifacts/12xqi4mw_IMG_1129.jpeg",
  ],
};
